<template>
  <id-pswd-wrtg v-if="step == 1"
                :tab-se="'pswd'"
                @next="comptPswdWrtg"
                @close="emits('close')"/>
  <pswd-stp v-if="step == 2"
            :mber-sn="mberSn"
            @chng="moveStep(1)"/>
  <pswd-compt v-if="step == 3"
              :mber-nm="mberNm"
              @close="emits('close')"/>
</template>

<script setup>
import IdPswdWrtg from "@/views/lgin/id-pswd-wrtg.vue";
import PswdStp from "@/views/lgin/pswd-stp.vue";
import PswdCompt from "@/views/lgin/pswd-compt.vue";

import {defineEmits, ref} from "vue";
import {getUtils, getStore} from "@/utils/import";
const {$axios, $alert, $cmmn} = getUtils();
const {$loading} = getStore();

const step = ref(1);
const mberSn = ref();
const mberNm = ref('');

const comptPswdWrtg = async ({mberNm: wrtgMberNm, mberId, mbpnTlno}) => {
  try {
    $loading.on();

    const {data} = await $axios.get('/api/mber/mber-sn/by-mber-nm-id-mbpn-tlno', {params : {mberNm: wrtgMberNm, mberId, mbpnTlno}});
    if (!data) {
      await $alert('입력한 정보와 일치하는 회원이 없습니다.<br/>정확한 정보를 입력해주세요.');
      return false;
    }

    mberNm.value = wrtgMberNm;
    mberSn.value = data;

    moveStep(1);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const moveStep = (setStep) => {
  step.value += setStep;
}

const emits = defineEmits(['close']);
</script>

<style scoped>

</style>
